import { createSlice } from '@reduxjs/toolkit';

export interface GridStates {
  services: any;
  allEvents: any;
  allContacts: any;
  salesContacts: any;
  salesEvents: any;
  allVenues?: any;
}

// initial state
const initialState: GridStates = {
  services: {},
  allEvents: {},
  allContacts: {},
  salesContacts: {},
  salesEvents: {},
  allVenues: {}
};

// ==============================|| SLICE - VENUE ||============================== //

const gridStates = createSlice({
  name: 'gridStates',
  initialState,
  reducers: {
    setServicesGridState(state, action) {
      state.services = action.payload;
    },
    setAllEventsGridState(state, action) {
      state.allEvents = action.payload;
    },
    setAllContactsGridState(state, action) {
      state.allContacts = action.payload;
    },
    setSalesContactsGridState(state, action) {
      state.salesContacts = action.payload;
    },
    setSalesEventsGridState(state, action) {
      state.salesEvents = action.payload;
    },
    setAllVenuesGridState(state, action) {
      state.allVenues = action.payload;
    }
  }
});

export default gridStates.reducer;

export const {
  setServicesGridState,
  setAllEventsGridState,
  setAllContactsGridState,
  setSalesContactsGridState,
  setSalesEventsGridState,
  setAllVenuesGridState
} = gridStates.actions;
